// Copyright (c) 2025 Audere, All Rights Reserved

import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const StyledStepper = styled(Stepper)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    width: theme.spacing(4),
    height: theme.spacing(4),
    fill: "none",
    border: `2px solid ${theme.palette.grey[400]}`,
    borderRadius: "50%",
  },
  "& .MuiStepLabel-label": {
    color: theme.palette.grey[400]
  },
  "& .MuiStepIcon-text": {
    fill: theme.palette.grey[400],
    fontSize: "10px",
  },
  "& .MuiSvgIcon-root.Mui-active": {
    border: `2px solid ${theme.palette.primary.main}`,
    "& .MuiStepIcon-text": {
      fill: theme.palette.primary.main,
    },
  },
  "& .MuiStepLabel-label.Mui-active": {
    color: theme.palette.primary.main
  }
}));

const CreateProjectStepper = (props: { steps: string[]; currentStep: number }) => {
  const { steps, currentStep } = props;
  return (
    <StyledStepper nonLinear activeStep={currentStep}>
      {steps.map((step, index) => (
        <Step key={index}>
          <StepLabel>{step}</StepLabel>
        </Step>
      ))}
    </StyledStepper>
  );
};

export default CreateProjectStepper;
